import React, { useState, useEffect } from "react";
import { database } from "../../../firebase/firebase";
import {
  ref,
  push,
  update,
  remove,
  set,
  onChildAdded,
  onChildRemoved,
  off, // Add this import
} from "firebase/database";
import PostForm from "./post-form";
import { Post } from "../types/post";
import PostTable from "./posts-table";

const AdminForm: React.FC = () => {
  const [selectedPost, setSelectedPost] = useState<Post | null>(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [posts, setPosts] = useState<Post[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    const postsRef = ref(database, "newsletter/posts");

    const handleChildAdded = (snapshot: any) => {
      const post = snapshot.val() as Post;
      setPosts((prevPosts) => [
        ...prevPosts,
        { ...post, id: snapshot.key as string },
      ]);
    };

    const handleChildRemoved = (snapshot: any) => {
      const removedPostId = snapshot.key;
      setPosts((prevPosts) =>
        prevPosts.filter((post) => post.id !== removedPostId)
      );
    };

    onChildAdded(postsRef, handleChildAdded);
    onChildRemoved(postsRef, handleChildRemoved);

    setLoading(false);

    return () => {
      // Cleanup listeners
      off(postsRef, "child_added", handleChildAdded);
      off(postsRef, "child_removed", handleChildRemoved);
    };
  }, []);

  console.log({ posts });

  const initialValues: Post = {
    id: "",
    author: "",
    redirectLink: "",
    readTime: 0,
    authorImage: "",
    imageUrl: "",
    publishedDate: "",
    description: "",
    title: "",
  };

  const handleSubmit = (
    values: Post,
    { resetForm }: { resetForm: () => void }
  ) => {
    if (selectedPost) {
      // Update existing post
      const postRef = ref(database, `newsletter/posts/${selectedPost.id}`);
      update(postRef, values)
        .then(() => {
          setSelectedPost(null);
          setIsModalOpen(false);
          resetForm();
        })
        .catch((error) => {
          console.error("Error updating post:", error);
        });
    } else {
      // Add new post with a random ID
      const newPostRef = push(ref(database, "newsletter/posts"));
      const newPostId = newPostRef.key;
      const newPost: Post = {
        ...values,
        id: newPostId as string,
      };
      set(newPostRef, newPost)
        .then(() => {
          resetForm();
        })
        .catch((error) => {
          console.error("Error adding post:", error);
        });
    }
  };

  const handleEditPost = (post: Post) => {
    setSelectedPost(post);
    setIsModalOpen(true);
  };

  const handleDeletePost = (postId: string) => {
    const postRef = ref(database, `newsletter/posts/${postId}`);
    remove(postRef)
      .then(() => {
        console.log("Post deleted successfully");
      })
      .catch((error) => {
        console.error("Error deleting post:", error);
      });
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Error: {error.message}</div>;
  }

  return (
    <div className="w-full">
      <h2 className="text-2xl font-bold mb-4">Admin Panel</h2>
      <button
        className="bg-blue-500 text-white py-2 px-4 rounded-md hover:bg-blue-600 mb-4"
        onClick={() => setIsModalOpen(true)}
      >
        Add Post
      </button>
      <PostTable
        posts={posts}
        onEditPost={handleEditPost}
        onDeletePost={handleDeletePost}
      />
      {isModalOpen && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 h-full w-full">
          <div className="bg-white p-8 rounded-md h-3/4 w-3/4 overflow-scroll">
            <h2 className="text-2xl font-bold mb-4">
              {selectedPost ? "Edit Post" : "Add Post"}
            </h2>
            <PostForm
              initialValues={selectedPost || initialValues}
              onSubmit={handleSubmit}
            />
            <button
              className="mt-4 bg-gray-500 text-white py-2 px-4 rounded-md hover:bg-gray-600"
              onClick={() => {
                setSelectedPost(null);
                setIsModalOpen(false);
              }}
            >
              Cancel
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdminForm;
